import { helper } from '@ember/component/helper';
const { add } = require('date-fns');
export default helper(function tomorrow() {
  return add(new Date(), { days: 1 });
});
